import { MenuMobileComponent } from './menu-mobile/menu-mobile.component';

export const sharedModals: any[] = [
  MenuMobileComponent,
];

export * from './menu-mobile/menu-mobile.component';
